import React, { Component, Fragment } from 'react';
import Header from '../Navigations/Header';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
// import * as actions from '../../store/actions/index'
// import Sidebar from './Sidebar'
// import withSession from "../../../hoc/withSession";
import Footer from '../Navigations/Footer/Footer'

import { Container, Row, Button, Col } from 'react-bootstrap';
import '../Main.css'

class Layout extends Component {
    state = {
        showBg: false
    }
    constructor(props) {
        super(props);
        
    }

    // componentDidMount() {
    //     window.addEventListener('scroll', this.handleOnScroll)


    // }

    // componentWillUnmount(){
    //     window.removeEventListener('scroll',this.handleOnScroll)
    // }

 
    menuMouseOver = (e) => {
        e.preventDefault();
        if (this.state.showBg) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        this.setState((prevState) => {
            return { showBg: !prevState.showBg }
        })
    }


    render() {

        const { showBg } = this.state;
        let activeMouseOver;

        if (showBg) {
            activeMouseOver = 'bgover'
        } else {
            activeMouseOver = ''
        }

        return (
            <Fragment>
                <Header SubMenuMouseOver={this.menuMouseOver} />
                <Container fluid className="bg-white pb-3">
                    <Row className="h-100">
                        <div className="d-flex w-100">
                            <div className={"flex-grow-1 "} >
                                {this.props.children}
                            </div>
                        </div>
                    </Row>
                </Container>
                <Footer />
            </Fragment>
        )
    }
}

export default (Layout);

